import http from '../http.service'

export class RestApiDataService {
  constructor (baseEntityUrl) {
    this.baseEntityUrl = baseEntityUrl
    this.http = http
  }

  getList (params) {
    params = params || {
      limit: 100000,
      offset: 0,
      page: 1,
    }
    return http.get(this.baseEntityUrl, {
      params: params,
    })
      .then(res => res.data.items)
  }

  getCustomItems (relativeUrl, payload = null) {
    return this.http.get(`${this.baseEntityUrl}/${relativeUrl}`, {
      params: payload,
    })
      .then((res) => res.data.items)
  }

  getOne (id) {
    return http.get(`${this.baseEntityUrl}/${id}`)
      .then(res => res.data.data)
  }

  create (data) {
    return http.post(this.baseEntityUrl, data)
      .then(res => res.data.data)
  }

  createWithFullResponse (data) {
    return http.post(this.baseEntityUrl, data)
      .then(res => res.data)
  }

  update (id, data) {
    return http.put(`${this.baseEntityUrl}/${id}`, data)
      .then(res => res.data.data)
  }

  updateWithFullResponse (id, data) {
    return http.put(`${this.baseEntityUrl}/${id}`, data)
      .then(res => res.data)
  }

  delete (id) {
    return http.delete(`${this.baseEntityUrl}/${id}`)
  }

  enable (id) {
    return http.patch(`${this.baseEntityUrl}/${id}/enable`)
  }

  disable (id) {
    return http.patch(`${this.baseEntityUrl}/${id}/disable`)
  }

  getCrudFields () {
    return []
  }
}
